import { createAction, props } from '@ngrx/store';
import { IOption } from '@shared';

export enum ActivitiesActionTypes {
  GET_ACTIVITIES = '[Activities] Get Activities',
  GET_ACTIVITIES_SUCCESS = '[Activities] Get Activities Success',
  GET_ACTIVITIES_FAILURE = '[Activities] Get Activities Failure',
}

export const getActivities = createAction(ActivitiesActionTypes.GET_ACTIVITIES);

export const getActivitiesSuccess = createAction(
  ActivitiesActionTypes.GET_ACTIVITIES_SUCCESS,
  props<{ activities: IOption[] }>(),
);

export const getActivitiesFailure = createAction(ActivitiesActionTypes.GET_ACTIVITIES_FAILURE);
